import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { signInOTP, signInPhone } from '../store/auth'
import { getFirebase } from "react-redux-firebase";
import M from "materialize-css";

class LoginPhone extends Component {
    state = {
        phoneNumber: '+91 ',
        otp: '',
        recaptchaVerifier: null
    }
    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    }
    componentDidMount = () => {
        M.updateTextFields();
        //setup captcha
        const firebase = getFirebase();
        this.state.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
            'size': 'invisible',
            'callback': (response) => {
                // reCAPTCHA solved, allow signInWithPhoneNumber.

            }
        });
    }
    handlePhoneSubmit = (e) => {
        e.preventDefault();

        this.props.signInPhone(this.state.phoneNumber, this.state.recaptchaVerifier)

    }
    handleOTPSubmit = (e) => {
        e.preventDefault();
        this.props.signInOTP(this.state.otp, this.props.auth.confirmationResult)
    }
    render() {
        const { auth, fbAuth } = this.props;
        if (fbAuth.uid) return <Redirect to='/' />
        return (
            <div className="container" style={{ marginTop: '20%' }}>
                <form className="white" onSubmit={this.handlePhoneSubmit}>
                    <div className="container">
                        <h5 className="grey-text text-darken-3">Enter your Phone Number</h5>
                        <div className="input-field">
                            <label htmlFor="phoneNumber">Phone Number</label>
                            <input type="tel" id='phoneNumber' value={this.state.phoneNumber} onChange={this.handleChange} />
                        </div>
                        <div className="input-field">
                            <button className="btn btn-large green">Get OTP</button>
                            <div className="center red-text">
                                {auth.authError ? <p>{auth.authError}</p> : null}
                            </div>
                        </div>
                        <br />
                    </div>
                    <div id="recaptcha-container" className='container'></div>
                </form>
                {auth.otp_sent &&
                    <form className="white" onSubmit={this.handleOTPSubmit}>
                        <div className="container">
                            <h5 className="grey-text text-darken-3">Enter One Time Password sent to your phone</h5>
                            <div className="input-field">
                                <label htmlFor="otp">OTP</label>
                                <input type="tel" id='otp' onChange={this.handleChange} />
                            </div>
                            <div className="input-field">
                                <button className="btn btn-large green">Submit</button>
                                <div className="center red-text">
                                    {auth.authError ? <p>{auth.authError}</p> : null}
                                </div>
                            </div>
                            <br />
                        </div>
                    </form>}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    fbAuth: state.firebase.auth
})

const mapDispatchToProps = (dispatch) => ({
    signInPhone: (phoneNumber, recaptchhaVerifier) => dispatch(signInPhone(phoneNumber, recaptchhaVerifier)),
    signInOTP: (code, confirmationResult) => dispatch(signInOTP(code, confirmationResult))
})

export default connect(mapStateToProps, mapDispatchToProps)(LoginPhone)